import { getBookingApiRoot } from '../helpers/bookingApiRoutes'

async function query(url, bookingNumber = null, data = null) {
    const bookingApiRoot = getBookingApiRoot()
    const payload = {
        booking_no: bookingNumber,
        data: data,
        arrival_date: bookingApiRoot?.dataset?.arrivalDate ?? null,
        booking_type: bookingApiRoot?.dataset?.bookingType ?? null,
        no_of_nights: bookingApiRoot?.dataset?.noOfNights ?? null,
        no_of_adults: bookingApiRoot?.dataset?.noOfAdults ?? null,
        no_of_children: bookingApiRoot?.dataset?.noOfChildren ?? null,
        no_of_pets: bookingApiRoot?.dataset?.noOfPets ?? null,
        park_code: bookingApiRoot?.dataset?.parkCode ?? null,
        grade_code: bookingApiRoot?.dataset?.gradeCode ?? null,
        id: bookingApiRoot?.dataset?.accommodationId ?? null,
        date_flexibility: bookingApiRoot?.dataset?.dateFlexibility ?? null,
    };

    try {
        const response = await axios.post(url, payload);

        return response.data;
    } catch (error) {
        // Re-throw the error to propagate it further up the chain
        throw error;
    }
}


export { query };
